import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import {
  createSubCategoryApi,
  updateSubCategoryApi,
} from "../../../services/ExpenseService";
import { getSearchExpenseCategory } from "../../../services/SearchService";
const AddSubCategoryModal = ({
  visible,
  onClose,
  onAfterSubmit,
  data = null,
}) => {
  const [loading, setLoading] = useState(false);
  const [categoryOptionLoading, setCategoryOptionLaoding] = useState(false);
  const [expenseCategoryOption, setExpenseCategoryOption] = useState([]);
  const [selectedExpenseCategory, setSelectedExpenseCategory] = useState(null);
  const [form, setForm] = useState({
    name: "",
    description: "",
    expense_category: "",
  });
  const [error, setError] = useState({});

  useEffect(() => {
    if (visible) {
      getCategory(data?.expense_category || "");
      handleReset();
    }
  }, [visible]);
  useEffect(() => {
    setForm({
      ...form,
      expense_category: selectedExpenseCategory?.value || "",
    });
    if (error?.expense_category && selectedExpenseCategory?.value) {
      setError({ ...error, expense_category: "" });
    }
  }, [selectedExpenseCategory]);
  const getCategory = (categoryId) => {
    setCategoryOptionLaoding(true);
    getSearchExpenseCategory()
      .then((res) => {
        const option = res?.data?.results || [];
        setExpenseCategoryOption(option);
        setSelectedExpenseCategory(
          option?.find((item) => item?.value == categoryId) || null
        );
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setCategoryOptionLaoding(false);
      });
  };

  const handleReset = () => {
    if (data) {
      setForm({
        name: data?.name || "",
        description: data?.description || "",
      });
    } else {
      setForm({
        name: "",
        description: "",
        expense_category: "",
      });
      setSelectedExpenseCategory(null);
    }
    setError({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({ ...prev, [name]: value }));

    if (value && error?.[name]) {
      setError((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = () => {
    let error = {};

    if (!form.name?.trim()) {
      error.name = "Name is required";
    }
    if (!form.expense_category) {
      error.expense_category = "Required Field";
    }

    setError(error);

    if (Object.keys(error).length === 0) {
      if (data) {
        updateSubCategory();
      } else {
        addSubCategory();
      }
    }
  };

  const updateSubCategory = () => {
    setLoading(true);
    updateSubCategoryApi(data?.id || "", form)
      .then(() => {
        toast.success("Sub-category update successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };
  const addSubCategory = () => {
    setLoading(true);
    createSubCategoryApi(form)
      .then(() => {
        toast.success("Sub-category Added successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {data ? "Updat Sub-category" : "Add Sub-category"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">
          <div className="row mb-2 gx-2">
            <div className="col-md-6">
              <label className="form-label text-dark">Category</label>
              <Select
                classNamePrefix="select"
                className="react-select"
               placeholder="e.g. Chemical"
                options={expenseCategoryOption}
                value={selectedExpenseCategory}
                onChange={setSelectedExpenseCategory}
                isLoading={categoryOptionLoading}
              />
              {error?.expense_category && (
                <small className="text-danger">{error.expense_category}</small>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label text-dark">Sub-Category</label>
              <input
                type="text"
                name="name"
                className={`form-control ${error?.name ? "is-invalid" : ""}`}
                value={form.name}
                placeholder="e.g. Polish"
                onChange={handleInputChange}
              />
              {error?.name && (
                <small className="text-danger">{error.name}</small>
              )}
            </div>
          </div>

          <div className="mb-2">
            <label className="form-label text-dark">Description</label>
            <textarea
              name="description"
              className='form-control'
              value={form.description}
              onChange={handleInputChange}
              rows={3}
              placeholder="Enter description"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end gap-2 w-100">
          <button
            className="btn btn-outline-dark"
            disabled={loading}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading && <Spinner animation="border" size="sm" />}
            {data ? "Update" : "Submit"}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddSubCategoryModal;
